import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getCityDetail } from "../actions";
import { useParams } from "react-router-dom";
import DetailCard from "../../../components/siteDetailCard";
import ProperSpinner from "../../../components/spinner/ProperSpinner";
import ImagePreviewer from "../../../components/imgSlider/ImagePreviewer";
import ImgSlider from "../../../components/imgSlider";

const CityDetail = () => {
  const { cityId } = useParams();
  const dispatch = useDispatch();
  const [city, setCity] = useState({});
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setLoading(true);
    dispatch(
      getCityDetail(cityId, (res) => {
        setCity(res);
        setLoading(false);
      })
    );
  }, []);

  if (loading) return <ProperSpinner />;
  console.log("city detail :", city);
  return (
    <div className="site-det-wrapper">
      <div className="site-det-header-container">
        <h3 className="w-50 mb-0 text-primary">{"City Detail"}</h3>
      </div>
      <div className="site-content-container ">
        {/* <div className="slider-container ">
          <div className="image-slider">
            <div className="main-image main-img-box">
              <img
                src={city.cityImage}
                alt="Selected"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/assets/images/defaultCityImage.jpg";
                }}
              />
            </div>
          </div>
        </div> */}
        <div className="slider-container ">
          {(city?.cityImage || city?.cityImage) && (
            <>
              <ImgSlider
                Images={[city.cityImage]}
                setSelectedPostIdx={0}
                setVisible={setVisible}
                selectedPostIdx={0}
              />
              <ImagePreviewer
                medias={[
                  {
                    src: city.cityImage,
                    alt: `Image ${0}`,
                  },
                ]}
                visible={visible}
                setVisible={setVisible}
                selectedPostIdx={0}
                setSelectedPostIdx={() => {}}
              />
            </>
          )}
        </div>
        <div className="site-details-main-container">
          <div className="site-info-contaianer">
            <div className="site-details-container-2">
              <div className="personal-info-container">
                <h4 className="label-text heading text-underline ">
                  {"City Details"}
                </h4>
                <div className="site-data-container">
                  <DetailCard data={city.cityName} label={"city Name"} />
                  <DetailCard data={city.state} label={"State"} />
                  <DetailCard data={city.country} label={"Country"} />
                  <DetailCard data={city.pinCode} label={"Postal Code"} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CityDetail;
